import { useActor } from '@xstate/react';
import { ArtistMachineActor } from '../../../machines/RedeemAccountInvitation/ArtistMachine';
import { ArtistView } from './ArtistView';

export function ArtistController({ actor }: { actor: ArtistMachineActor }) {
  const [state, send] = useActor(actor);

  return <ArtistView state={state} send={send} />;
}
